<template>
<div class="medidas-page">
    <!-- Card de búsqueda -->
    <b-card no-body class="card-busqueda mb-1">
      <b-card-header class="pb-0">
        <div class="d-flex align-items-center">
          <div class="icon-busqueda mr-1">
            <feather-icon icon="SearchIcon" size="20" />
          </div>
          <div>
            <h4 class="mb-0">Buscar por dimensiones</h4>
            <small class="text-muted">Introduce las medidas del dispositivo para encontrar fundas compatibles</small>
          </div>
        </div>
      </b-card-header>
      <b-card-body class="pt-1">
        <b-row class="align-items-end">
          <!-- Ancho -->
          <b-col cols="12" md="2">
            <b-form-group class="mb-md-0">
              <label class="medida-label">
                <i class="fa-solid fa-arrows-left-right medida-icon"></i> Ancho
                <b-badge v-if="anchoCalculado" variant="light-primary" class="ml-50">{{ anchoCalculado }}</b-badge>
              </label>
              <b-form-input
                id="inputAnchoForm"
                ref="inputAnchoForm"
                placeholder="cm"
                v-model="inputAnchoBuscar"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
          <!-- Alto -->
          <b-col cols="12" md="2">
            <b-form-group class="mb-md-0">
              <label class="medida-label">
                <i class="fa-solid fa-arrows-up-down medida-icon"></i> Alto
                <b-badge v-if="altoCalculado" variant="light-info" class="ml-50">{{ altoCalculado }}</b-badge>
              </label>
              <b-form-input
                placeholder="cm"
                v-model="inputAltoBuscar"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
          <!-- Profundo -->
          <b-col cols="12" md="2">
            <b-form-group class="mb-md-0">
              <label class="medida-label">
                <i class="fa-solid fa-cube medida-icon"></i> Profundo
              </label>
              <b-form-input
                placeholder="cm"
                v-model="inputProfundoBuscar"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
          <!-- Categoría -->
          <b-col cols="12" md="3">
            <b-form-group class="mb-md-0">
              <label class="medida-label">
                <i class="fa-solid fa-layer-group medida-icon"></i> Categoría
              </label>
              <v-select
                v-model="categoriaSelect"
                label="nombre"
                :options="listadoCategoria"
                class="select-categoria"
              />
            </b-form-group>
          </b-col>
          <!-- SKU por producto -->
          <b-col cols="12" md="3">
            <div class="switch-sku-producto mb-md-0">
              <b-form-checkbox
                name="check-button"
                switch
                inline
                v-model="skuPorProducto"
              >
                <span class="switch-label">Mejor SKU por producto</span>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <!-- Card de listado -->
    <b-card no-body class="card-listado">
      <b-card-header class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <h4 class="mb-0">Listado SKU</h4>
          <b-badge variant="primary" pill class="ml-1">{{ articulosBusqueda.length }}</b-badge>
        </div>
        <div class="d-flex align-items-center">
          <b-form-checkbox
            class="custom-control-success mr-1"
            name="check-button"
            switch
            v-model="imgTable"
          >
            <feather-icon :icon="imgTable ? 'CameraIcon' : 'CameraOffIcon'" size="16" />
          </b-form-checkbox>
          <b-button variant="flat-primary" size="sm" @click="abrirModalJson()" class="btn-json">
            <feather-icon icon="CodeIcon" size="16" class="mr-50" />
            JSON
          </b-button>
        </div>
      </b-card-header>
      <b-card-body class="pt-0">
        <b-form-input
          id="basicInput"
          placeholder="Buscar por SKU, producto o variante..."
          v-model="buscar"
          class="input-buscar-tabla mb-1"
        />
        <b-table
          :items="articulosBusqueda"
          :fields="columnasTable"
          class="table-medidas"
          striped
          hover
          responsive
          sort-icon-left
          show-empty
          empty-text="No se encontraron resultados"
        >
          <template #cell(img)="data">
            <img :src="data.item.image" alt="" class="imagen_material rounded">
          </template>

          <template #cell(ancho)="data">
            <b-badge :variant="data.item.ancho ? 'light-success' : 'light-secondary'" class="badge-medida">
              {{ data.item.ancho || '-' }}
            </b-badge>
          </template>

          <template #cell(alto)="data">
            <b-badge :variant="data.item.alto ? 'light-info' : 'light-secondary'" class="badge-medida">
              {{ data.item.alto || '-' }}
            </b-badge>
          </template>

          <template #cell(stock)="data">
            <b-badge :variant="data.item.stock > 0 ? 'light-success' : 'light-danger'" pill>
              {{ data.item.stock }}
            </b-badge>
          </template>

          <template #cell(options)="data">
            <b-button variant="flat-primary" class="btn-icon rounded-circle btn-sm" @click="openTimesSku(data.item)" v-b-tooltip.hover title="Editar medidas">
              <feather-icon icon="EditIcon" size="16" />
            </b-button>
          </template>

          <template #cell(web)="data">
            <div class="d-flex">
              <b-button variant="flat-success" class="btn-icon rounded-circle btn-sm mr-50" @click="copyUrl(data.item)" v-b-tooltip.hover title="Copiar URL">
                <feather-icon icon="CopyIcon" size="16" />
              </b-button>
              <b-button variant="flat-secondary" class="btn-icon rounded-circle btn-sm" @click="openUrl(data.item)" v-b-tooltip.hover title="Abrir en web">
                <feather-icon icon="ExternalLinkIcon" size="16" />
              </b-button>
            </div>
          </template>

        </b-table>
      </b-card-body>
    </b-card>

    <!-- Modal editar medidas -->
    <b-modal
      ref="modal-medidas"
      centered
      hide-footer
      size="lg"
      modal-class="modal-medidas"
    >
      <template #modal-header="{ close }">
        <div class="modal-header-medidas w-100">
          <div class="d-flex align-items-center">
            <div class="icon-modal-medidas mr-1">
              <feather-icon icon="MaximizeIcon" size="20" />
            </div>
            <div>
              <h5 class="mb-0">Editar medidas</h5>
              <small class="text-muted">{{ skuSelectTitle }}</small>
            </div>
          </div>
          <feather-icon icon="XIcon" size="20" class="cursor-pointer" @click="close()" />
        </div>
      </template>
      <div class="p-1">
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="medida-label">
                <i class="fa-solid fa-arrows-left-right medida-icon"></i> Ancho
              </label>
              <b-form-input
                id="inputAnchoFormModal"
                ref="inputAnchoForm"
                placeholder="cm"
                v-model="inputAncho"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="medida-label">
                <i class="fa-solid fa-arrows-up-down medida-icon"></i> Alto
              </label>
              <b-form-input
                placeholder="cm"
                v-model="inputAlto"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="medida-label">
                <i class="fa-solid fa-cube medida-icon"></i> Profundo
              </label>
              <b-form-input
                placeholder="cm"
                v-model="inputProfundo"
                class="input-medida"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="text-center mt-1">
          <b-button variant="primary" @click="guardarMedidas()" class="px-3">
            <feather-icon icon="SaveIcon" size="16" class="mr-50" />
            Guardar
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal exportar JSON -->
    <b-modal
      ref="modal-json-export"
      centered
      hide-footer
      size="sm"
      modal-class="modal-medidas"
    >
      <template #modal-header="{ close }">
        <div class="modal-header-medidas w-100">
          <div class="d-flex align-items-center">
            <div class="icon-modal-json mr-1">
              <feather-icon icon="CodeIcon" size="20" />
            </div>
            <div>
              <h5 class="mb-0">Exportar JSON</h5>
              <small class="text-muted">Copia las medidas de un producto</small>
            </div>
          </div>
          <feather-icon icon="XIcon" size="20" class="cursor-pointer" @click="close()" />
        </div>
      </template>
      <div class="p-1">
        <b-form-group>
          <label class="medida-label">
            <i class="fa-solid fa-barcode medida-icon"></i> Código artículo
          </label>
          <b-form-input
            id="inputCodigoArt"
            ref="inputCodigoArt"
            placeholder="Introduce el código del producto"
            v-model="inputCodigo"
            class="input-medida"
          />
        </b-form-group>
        <div class="text-center mt-1">
          <b-button variant="primary" @click="obtenerJson()" class="px-3">
            <feather-icon icon="ClipboardIcon" size="16" class="mr-50" />
            Copiar Datos
          </b-button>
        </div>
      </div>
    </b-modal>
</div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  data(){
    return{
      buscar: "",
      columnasTable: [{
              key: "options",
              label: "",
              thStyle: { width: "60px" },
            },{
              key: "product",
              label: "Código",
              sortable: true,
              thStyle: { width: "100px" },
            },{
              key: "productTitle",
              label: "Producto",
              sortable: true,
            },{
              key: "skuTitle",
              label: "Variante",
              sortable: true,
            },{
              key: "sku",
              label: "SKU",
              sortable: true,
            }, {
              key: "ancho",
              label: "Ancho",
              sortable: true,
              thStyle: { width: "90px" },
              tdClass: "text-center",
            }, {
              key: "alto",
              label: "Alto",
              sortable: true,
              thStyle: { width: "90px" },
              tdClass: "text-center",
            },{
              key: "stock",
              label: "Stock",
              sortable: true,
              thStyle: { width: "80px" },
              tdClass: "text-center",
            }, {
              key: "web",
              label: "URL",
              thStyle: { width: "110px" },
            }],
      articulos: [],
      articulosBusqueda: [],
      imgTable: false,
      skuSelectTitle: "",
      skuSelect: {ancho: "", alto: "", profundo: ""},
      inputAncho: "",
      inputAlto: "",
      inputProfundo: "",
      inputAnchoBuscar: "",
      inputAltoBuscar: "",
      inputProfundoBuscar: "",
      categoriaSelect: "Todos",
      listadoCategoria: ["Todos", "Móviles", "Tablets", "Portátiles"],
      skuPorProducto: false,
      inputCodigo: "",
      anchoCalculado: "",
      altoCalculado: "",
      allVariants: []
    }
  },
  methods:{
    load(){
      axios.post("/uso", {seccion:"medidas"});
      axios
        .get("/medidas/variants")
        .then(response => {
            return response.data;
        })
        .then(resArticulos => {
            this.articulos = resArticulos;
            this.articulosBusqueda = this.articulos;
        });

      axios
        .get("/medidas/variants/all")
        .then(response => {
            return response.data;
        })
        .then(resAllVariants => {
            this.allVariants = resAllVariants;
        });
    },
    buscarFuncion(){
      this.articulosBusqueda = [];

      if(this.inputAnchoBuscar == "" && this.inputAltoBuscar == "" && this.inputProfundoBuscar)
      {
         this.articulos.forEach(mat => {
            if(mat.sku.toLowerCase().includes(this.buscar.toLowerCase()) || 
              mat.productTitle.toLowerCase().includes(this.buscar.toLowerCase()) ||
              mat.skuTitle.toLowerCase().includes(this.buscar.toLowerCase())
            )
              {
                this.articulosBusqueda.push(mat);
              }
          });
      }
      else
      {
        this.buscarProductos();
      }
    },
    openTimesSku(data)
    {
      this.skuSelectTitle = data.sku;
      this.skuSelect = data;

      let dataInfo = JSON.parse(JSON.stringify(data));

      this.inputAncho = dataInfo.ancho;
      this.inputAlto = dataInfo.alto;
      this.inputProfundo = dataInfo.profundo;

      this.$refs['modal-medidas'].show();
      setTimeout(()=>{this.$refs.inputAnchoForm.focus(); }, 300); 
    },
    guardarMedidas(){

      let infoTime = {
        sku: this.skuSelect.sku,
        ancho: this.inputAncho,
        alto: this.inputAlto,
        profundo: this.inputProfundo,
        product:this.skuSelect.product,
      }


      axios
        .post("/medidas", infoTime)
        .then(response => {
            return response.data;
        })
        .then(res => {
        });


      this.skuSelect.ancho = this.inputAncho;
      this.skuSelect.alto = this.inputAlto;
      this.skuSelect.profundo = this.inputProfundo;

      this.$refs['modal-medidas'].hide();
      
    },
    buscarProductos(){

      let anchoParseado = 0;
      let altoParseado = 0;
      let profundoParseado = 0;

      if(this.inputAnchoBuscar != "") anchoParseado = this.inputAnchoBuscar.replaceAll(',','.');
      if(this.inputAltoBuscar != "") altoParseado = this.inputAltoBuscar.replaceAll(',','.');
      if(this.inputProfundoBuscar != "") profundoParseado = this.inputProfundoBuscar.replaceAll(',','.');

      let ancho = parseFloat(anchoParseado);
      let alto = parseFloat(altoParseado);
      let profundo = parseFloat(profundoParseado);      

      let anchoTotal = ancho + profundo + 0.5;

      let anchoTotal2 = alto + profundo + 0.5;
      let alto2 = ancho;

      let articulosValidos = [];

      this.articulosBusqueda = [];

      this.anchoCalculado = anchoTotal;
      this.altoCalculado = alto;

      //20+10 = 30
      // 13.3 + 7.6 = 20.9

      this.articulos.forEach(articulo => {
        if((articulo.ancho >= anchoTotal && articulo.alto >= alto ) || (articulo.ancho >= anchoTotal2 && articulo.alto >= alto2 ))
        {
          //input buscador
           if(articulo.sku.toLowerCase().includes(this.buscar.toLowerCase()) || 
              articulo.productTitle.toLowerCase().includes(this.buscar.toLowerCase()) ||
              articulo.skuTitle.toLowerCase().includes(this.buscar.toLowerCase())
            )
            {

              let skuTitle = articulo.skuTitle.toLowerCase();
              //categoria seleccionada
              if(this.categoriaSelect == "Todos")
                articulosValidos.push(articulo);
              else if(this.categoriaSelect == "Móviles" && (skuTitle.includes("iphone") || skuTitle.includes("smartphone") || skuTitle.includes("samsung") || skuTitle.includes("nexus")  ))
                articulosValidos.push(articulo);
              else if(this.categoriaSelect == "Tablets" && (skuTitle.includes("ipad") || skuTitle.includes("surface") || skuTitle.includes("kindle") ))
                articulosValidos.push(articulo);
              else if(this.categoriaSelect == "Portátiles" && !skuTitle.includes("ipad") && !skuTitle.includes("surface") && !skuTitle.includes("kindle") && !skuTitle.includes("iphone") && !skuTitle.includes("smartphone") && !skuTitle.includes("samsung") &&  !skuTitle.includes("nexus") )
                articulosValidos.push(articulo);
            }
        }
      });

      if(!this.skuPorProducto)
      {
        this.articulosBusqueda = articulosValidos;
      }
      else
      {

        let puntuacionBuscar = anchoTotal + alto;

        articulosValidos.forEach(articulo => {

            //Busco si ese produto ya lo he metido
           let index = this.articulosBusqueda.findIndex(x => x.product === articulo.product);
            if (index == -1) { //Si no busco el mejor sku
              let serie = articulosValidos.filter(function (el) {
                  return el.product == articulo.product;
                });

                let mejorArticulo = null;
                let mejorArticuloPuntuacion = 9999;

                serie.forEach(articuloSerie => {
                  let puntuacion = parseFloat(articuloSerie.ancho) + parseFloat(articuloSerie.alto);

                  if(puntuacion-puntuacionBuscar < mejorArticuloPuntuacion)
                  {
                    mejorArticuloPuntuacion = puntuacion-puntuacionBuscar;
                    mejorArticulo = articuloSerie;
                  }
                  
                });

                this.articulosBusqueda.push(mejorArticulo);
            }

        });
      }

    },
    openUrl(data)
    {
      window.open(data.url, '_blank').focus();
    },
    copyUrl(data){
       navigator.clipboard.writeText(data.url)
    },
    abrirModalJson(){
      this.$refs['modal-json-export'].show();
      this.inputCodigo = "";
      setTimeout(()=>{this.$refs.inputCodigoArt.focus(); }, 300); 
    },
    obtenerJson(){
      let res = [];

      const variantesFiltradas = this.allVariants.filter(variant => variant.shopify_product_id == this.inputCodigo);

      variantesFiltradas.forEach(variante => {
        let varianteFind = this.articulos.find((e) => e.sku === variante.sku);

        if(varianteFind)
        {
          if(varianteFind.ancho != "")
          {
            const existingObj = res.find(obj => obj.sku === varianteFind.sku);
            
            if (!existingObj) 
              res.push({"sku": varianteFind.sku, "ancho": varianteFind.ancho, "alto": varianteFind.alto})
          }          
        }
      });      

      /*let articuloFind = this.articulos.find((e) => e.productMedida === this.inputCodigo);

      if(articuloFind)
        productId = articuloFind.product;
      else
      {
        let articuloFindSku = this.articulos.find((e) => e.sku === this.inputCodigo);
        if(articuloFindSku)
          productId = articuloFindSku.product;
      }

      this.articulos.forEach(articulo => {

        if(articulo.product == productId)
        {
          if(articulo.ancho != "")
            res.push({"sku": articulo.sku, "ancho": articulo.ancho, "alto": articulo.alto})
        }
      });*/

      navigator.clipboard.writeText(JSON.stringify(res));

      this.$bvToast.toast(`Se han copiado ${res.length} medidas`, {
                  title: 'Medidas Copiadas',
                  variant: 'success',
                  solid: true,
                })
    }

  },
  watch: {
      buscar(){
        this.buscarFuncion();
      },
      categoriaSeleccionada(){
        this.buscarFuncion();
      },
      imgTable(){

        if(this.imgTable)
        {
          this.columnasTable.unshift({
            key: "img",
            label: "Img",
            sortable: false,
            thStyle: { width: "10%" },
          })
        }
        else
        {
          this.columnasTable.shift();
        }
        
      },
      inputAnchoBuscar(){
        this.buscarProductos();
      },
      inputAltoBuscar(){
        this.buscarProductos();
      },
      inputProfundoBuscar(){
        this.buscarProductos();
      },
      categoriaSelect(){
        this.buscarProductos();
      },
      skuPorProducto(){
        this.buscarProductos();
      }
  },
  mounted() {    
    this.load();
  }
}
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .medidas-page {
    input[type="file"] {
      display: none;
    }

    // Card de búsqueda
    .card-busqueda {
      border: none;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

      .icon-busqueda {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        background: linear-gradient(135deg, #7367f0 0%, #9e95f5 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }

      .medida-label {
        font-size: 0.857rem;
        font-weight: 600;
        color: #5e5873;
        display: flex;
        align-items: center;
        margin-bottom: 0.4rem;

        .medida-icon {
          color: #7367f0;
          margin-right: 6px;
          font-size: 13px;
        }
      }

      .input-medida {
        border-radius: 8px;
        border: 1px solid #ebe9f1;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
          border-color: #7367f0;
          box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
        }
      }

      .select-categoria {
        .vs__dropdown-toggle {
          border-radius: 8px;
          border: 1px solid #ebe9f1;
        }
      }

      .switch-sku-producto {
        padding: 0.6rem 0;

        .switch-label {
          font-size: 0.857rem;
          color: #5e5873;
        }
      }
    }

    // Card de listado
    .card-listado {
      border: none;
      box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);

      .btn-json {
        font-weight: 500;
      }

      .input-buscar-tabla {
        border-radius: 8px;
        border: 1px solid #ebe9f1;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
          border-color: #7367f0;
          box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
        }
      }

      .table-medidas {
        border-radius: 8px;

        thead th {
          text-transform: uppercase;
          font-size: 0.75rem;
          letter-spacing: 0.5px;
          color: #6e6b7b;
          border-bottom: 2px solid #ebe9f1;
          padding: 0.8rem 1rem;
          white-space: nowrap;
        }

        tbody td {
          padding: 0.65rem 1rem;
          vertical-align: middle;
          font-size: 0.9rem;
        }

        .badge-medida {
          font-size: 0.85rem;
          font-weight: 500;
          padding: 0.4rem 0.7rem;
          min-width: 45px;
          text-align: center;
        }
      }
    }

    .imagen_material {
      width: 80px;
      max-height: 60px;
      object-fit: cover;
      border: 1px solid #ebe9f1;
    }
  }

  // Modal de medidas
  .modal-medidas {
    .modal-content {
      border-radius: 12px;
      border: none;
      overflow: hidden;
    }

    .modal-header {
      padding: 0;
      border-bottom: 1px solid #ebe9f1;
    }

    .modal-header-medidas {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1.2rem 1.4rem;
    }

    .icon-modal-medidas {
      width: 38px;
      height: 38px;
      border-radius: 8px;
      background: linear-gradient(135deg, #28c76f 0%, #48da89 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }

    .icon-modal-json {
      width: 38px;
      height: 38px;
      border-radius: 8px;
      background: linear-gradient(135deg, #ff9f43 0%, #ffb976 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
    }

    .medida-label {
      font-size: 0.857rem;
      font-weight: 600;
      color: #5e5873;
      display: flex;
      align-items: center;
      margin-bottom: 0.4rem;

      .medida-icon {
        color: #7367f0;
        margin-right: 6px;
        font-size: 13px;
      }
    }

    .input-medida {
      border-radius: 8px;
      border: 1px solid #ebe9f1;
      transition: border-color 0.2s, box-shadow 0.2s;

      &:focus {
        border-color: #7367f0;
        box-shadow: 0 3px 10px 0 rgba(115, 103, 240, 0.15);
      }
    }
  }
</style>